export default __webpack_public_path__ + "static/media/inspiration5.0ce79776.jpg";